import styled from "styled-components";
import loginBackground from "../../../images/login-bg.jpg";

export const Container = styled.div`
  background: url(${loginBackground}) center 120px no-repeat;
  backgroundcolor: #093949;
  zindex: -0;
`;
